import React from 'react';
import './news.css';
import { Helmet } from "react-helmet-async";
import NewsHeader from './newsheader/NewsHeader';
import NewsDisplay from './newsdisplay/NewsDisplay';

const News = () => {
    return (
        <>
            <Helmet>
                <title>Nyheter från Cycle Solutions | Uppdateringar</title>
                <meta
                    name="description"
                    content="Nyheter från Cycle Solutions om komprimatorer, balpressar och smart avfallshantering. Läs om nya produkter och kundcase."
                />
                <link
                    rel="canonical"
                    href="https://cyclesolutions.se/nyheter"
                />
            </Helmet>

            <div className='news'>
                <NewsHeader />
                <NewsDisplay />
            </div>
        </>
    );
};

export default News;
